import * as React from 'react';
import { Checkbox } from '@cian/ui-kit/checkbox';
import { UiKitContext } from '@cian/ui-kit/internal/context';
import { IUiKitContext } from '@cian/ui-kit';

import * as styles from './styles.css';

export interface ICheckMarkProps {
  checked: boolean;
}

export const CheckMark: React.FC<React.PropsWithChildren<ICheckMarkProps>> = ({ checked }) => {
  const context: IUiKitContext = React.useMemo(
    () => ({
      deviceType: 'phone',
      useStaticDeviceType: true,
    }),
    [],
  );

  return (
    <UiKitContext.Provider value={context}>
      <div className={styles['container']}>
        <Checkbox checked={checked} underline={false} />
      </div>
    </UiKitContext.Provider>
  );
};

CheckMark.displayName = 'CheckMark';
